// extracted by mini-css-extract-plugin
module.exports = {"component":"styles-module--component--bOqPC","logo":"styles-module--logo--3SEpy","menu":"styles-module--menu--1BlH2"};